/* eslint-disable */
export default {
  _decorate_background: 'decorate_background',
  _intro_background: 'intro_background',
  _house3_light: 'house3_light',
  _house3_dark: 'house3_dark',
  _house4_dark: 'house4_dark',
  _house4_light: 'house4_light',
  _house6_dark: 'house6_dark',
  _house10_dark: 'house10_dark',
  _house11_dark: 'house11_dark',
  _percentage_bar: 'percentage_bar',
  _large_house: 'large_house',
  _house8_dark: 'house8_dark',
  _house10_light: 'house10_light',
  _sprites_santa_body: 'sprites/santa_body',
  _sprites_guitar_button: 'sprites/guitar_button',
  _sprites_keyboard_button: 'sprites/keyboard_button',
  _sprites_go_button: 'sprites/go_button',
  _sprites_clear_button: 'sprites/clear_button',
  _sprites_1_button: 'sprites/1_button',
  _sprites_3_button: 'sprites/3_button',
  _sprites_santa_right_leg: 'sprites/santa_right_leg',
  _sprites_6_button: 'sprites/6_button',
  _sprites_7_button: 'sprites/7_button',
  _back_button: 'back_button',
  _sprites_snow_flake: 'sprites/snow_flake',
  _sprites_blue_light_on: 'sprites/blue_light_on',
  _sprites_green_light_on: 'sprites/green_light_on',
  _sprites_red_light_on: 'sprites/red_light_on',
  _sprites_yellow_light_on: 'sprites/yellow_light_on',
  _sprites_blue_light_off: 'sprites/blue_light_off',
  _sprites_green_light_off: 'sprites/green_light_off',
  _sprites_red_light_off: 'sprites/red_light_off',
  _sprites_yellow_light_off: 'sprites/yellow_light_off',
  _house5_dark: 'house5_dark',
  _house5_light: 'house5_light',
  _house9_light: 'house9_light',
  _house1_dark: 'house1_dark',
  _house1_light: 'house1_light',
  _house6_light: 'house6_light',
  _house12_dark: 'house12_dark',
  _house12_light: 'house12_light',
  _house11_light: 'house11_light',
  _house8_light: 'house8_light',
  _house7_dark: 'house7_dark',
  _house9_dark: 'house9_dark',
  _house7_light: 'house7_light',
  _house2_dark: 'house2_dark',
  _house2_light: 'house2_light',
  _small_house: 'small_house',
  _sprites_enter_button: 'sprites/enter_button',
  _sprites_0_button: 'sprites/0_button',
  _sprites_2_button: 'sprites/2_button',
  _sprites_4_button: 'sprites/4_button',
  _sprites_5_button: 'sprites/5_button',
  _sprites_9_button: 'sprites/9_button',
  _sprites_divide_button: 'sprites/divide_button',
  _sprites_santa_right_arm: 'sprites/santa_right_arm',
  _sprites_santa_left_leg: 'sprites/santa_left_leg',
  _sprites_santa_left_arm: 'sprites/santa_left_arm',
  _sprites_minus_button: 'sprites/minus_button',
  _sprites_plus_button: 'sprites/plus_button',
  _sprites_times_button: 'sprites/times_button',
  _sprites_8_button: 'sprites/8_button',
}